module.exports = __webpack_public_path__ + "static/media/programming-svgrepo-com (2).2a9b1661.svg";